// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__QDdMJ","loaderOuter":"PageOverlayLoader_loaderOuter__vBT01"};